module.exports = __webpack_public_path__ + "static/media/one_marker_hover.7f5c9ef8.svg";